import Vue from "vue";
import RequestRepository from "@/repositories/request/RequestRepository";
import {Type} from "@/modules/request/Type";
import Owner from "@/model/cospirit-api/Owner";

export interface Request {
    uuid: string | null;
    code: string | null;
    title: string;
    status: string;
    type: Type;
    description: string;
    beginDate: string;
    endDate: string;
    topic: Uuidable | null;
    subtopic: Uuidable | null;
    area: string;
    brief: string;
    orderNumber: string | null;
    owner: Owner;
    scopeOwner: Uuidable | null;
    hierarchyOwner?: Uuidable | null;
    allocations: Allocation[];
    parent: Parent | null;
    children: Request[];
    assignedUsers: User[];
    followers: User[];
    createdBy: User;
    createdAt: string;
    requestDocumentMediaCampaigns: RequestDocumentMediaCampaign[];
    mediaCampaign: Uuidable | null;
}

export interface User {
    uuid?: string;
    displayName?: string;
    department?: {
        name: string;
    };
}

export interface Uuidable {
    uuid: string | null;
}

export interface Parent {
    uuid: string;
}

export interface Allocation {
    uuid: string | null;
    amount: number;
    amountMin: number | null;
    budgetAllocation: BudgetAllocation;
}

export interface BudgetAllocation {
    uuid: string | null;
}

export interface RequestDocumentMediaCampaign {
    uuid: string | null;
    createdBy: User;
    createdAt: string;
    mediaCampaign: {
        uuid: string;
        title: string | null;
    };
    document: {
        uuid: string;
        link: string | null;
        clientOriginalFileName: string | null;
    };
}

export default {
    state: {
        requesters: [],
        assignedUsers: [],
        followers: [],
    },
    mutations: {
        setRequesters: (state: any, requesters: User[]) => {
            Vue.set(state, "requesters", requesters);
        },
        setAssignedUsers: (state: any, assignedUsers: User[]) => {
            Vue.set(state, "assignedUsers", assignedUsers);
        },
        setFollowers: (state: any, followers: User[]) => {
            Vue.set(state, "followers", followers);
        },
    },
    getters: {
        getRequesters: (state: any) => {
            return state.requesters;
        },
        getAssignedUsers: (state: any) => {
            return state.assignedUsers;
        },
        getFollowers: (state: any) => {
            return state.followers;
        },
    },
    actions: {
        loadRequesters: ({commit}: any, ownerUuid: string) => {
            const filters = {
                listRequestersUsers: true,
                status: ["opened"],
                ownerUuid
            };
            const fields = [
                "createdBy.displayName",
                "createdBy.uuid"
            ];
            const params = {filters, fields};
            RequestRepository.get(params).then((data: any) => {
                commit("setRequesters", data);
            });
        },

        loadAssignedUsers: ({commit}: any, ownerUuid: string) => {
            const filters = {
                listAssignedUsers: true,
                status: ["opened"],
                ownerUuid
            };
            const fields = [
                "assignedUsers.displayName",
            ];
            const params = {filters, fields};
            RequestRepository.get(params).then((data: any) => {
                commit("setAssignedUsers", data);
            });
        },
    },
};
